import { format } from "date-fns";
import React from "react";
import { useFormContext } from "react-hook-form";
import { Table } from "antd";
import { useFormattedUserListOption } from "core/Operations/formattedOption/useFormattedMasterOptions";
import Input from "Components/UI/Input";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
const ApplyLeaveDayDetails = () => {
  const [totalPaidLeave, setTotalPaidLeave] = React.useState(0);
  const { watch, setValue } = useFormContext();

  const userOptions = useFormattedUserListOption({
    companyCode: watch("companyCode"),
    locationCode: watch("locationCode"),
  });

  const onHalfDayChange = (e, index) => {
    if (e.target.checked) {
      setValue(`details.${index}.noOfDays`, 0.5);
    } else {
      setValue(`details.${index}.noOfDays`, 1);
    }
    setValue(`details.${index}.isHalfDay`, e.target.checked);

    totalPaidLeaveHandler();
  };

  const onPaidLeaveChange = (e, index) => {
    setValue(`details.${index}.isPaidLeave`, e.target.checked);
    totalPaidLeaveHandler();
  };

  const totalPaidLeaveHandler = () => {
    const details = watch("details") || [];

    const paidLeaveTotal =
      watch("balanceLeave") -
      details.reduce(
        (sum, item) =>
          sum + (item.isPaidLeave ? Number(item.noOfDays) || 0 : 0),
        0
      );

    const newDetails = details.map((item) => {
      paidLeaveTotal;
      return {
        ...item,
        enablePaidLeave: paidLeaveTotal >= item.noOfDays ? true : false,
      };
    });
    console.log(newDetails);
    setValue("details", newDetails);

    // setTotalPaidLeave(paidLeaveTotal);
  };

  const setNoOfDays = () => {
    const totalLeaveDays = watch("details")?.reduce(
      (sum, d) => sum + (d.isHalfDay ? 0.5 : 1),
      0
    );
    console.log("noOfDays", totalLeaveDays);
    setValue("noOfDays", totalLeaveDays);
    // setValue("selectedLeaveDates", validLeaveDates); // Store for useEffect

    // setValue("isPaidLeave", totalLeaveDays <= watch("balanceLeave"));
  };

  const columns = [
    {
      title: "Leave Date",
      dataIndex: "leaveFrom",
      render: (text) => format(new Date(text), "yyyy-MM-dd"),
    },
    {
      title: () => (
        <div className="d-flex flex-column align-items-center">
          <span>Is Half Day</span>
          <input
            type="checkbox"
            className="form-check-input mt-1"
            onChange={(e) => {
              const checked = e.target.checked;
              const details = watch("details");
              details.forEach((_, index) => {
                setValue(`details.${index}.isHalfDay`, checked);
              });
              setNoOfDays();
            }}
            // checked={watch("details")?.every((item) => item.isHalfDay)}
          />
          <small className="text-muted">Select All</small>
        </div>
      ),
      dataIndex: "isHalfDay",
      render: (text, record, index) => (
        <div className="d-flex justify-content-center align-items-center mb-0">
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id={`is-half-day-${index}`}
              checked={watch(`details.${index}.isHalfDay`)}
              onChange={(e) => {
                onHalfDayChange(e, index);
                setNoOfDays();
              }}
            />
            <label
              className="form-check-label"
              htmlFor={`is-half-day-${index}`}
            >
              {watch(`details.${index}.isHalfDay`) ? "Yes" : "No"}
            </label>
          </div>
        </div>
      ),
    },
    {
      title: () => (
        <div className="d-flex flex-column align-items-center">
          <span>Is Paid Leave</span>
          <input
            type="checkbox"
            className="form-check-input mt-1"
            onChange={(e) => {
              const checked = e.target.checked;
              const details = watch("details");
              details.forEach((row, index) => {
                if (row.enablePaidLeave !== false) {
                  setValue(`details.${index}.isPaidLeave`, checked);
                }
              });
            }}
            checked={watch("details")?.every((item) => item.isPaidLeave)}
            disabled={watch("details")?.every(
              (item) => item.enablePaidLeave === false
            )}
          />
          <small className="text-muted">Select All</small>
        </div>
      ),
      dataIndex: "isPaidLeave",
      render: (text, record, index) => (
        <div className="d-flex justify-content-center align-items-center mb-0">
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id={`paid-leave-${index}`}
              checked={watch(`details.${index}.isPaidLeave`)}
              onChange={(e) => onPaidLeaveChange(e, index)}
              disabled={watch(`details.${index}.enablePaidLeave`) === false}
            />
            <label className="form-check-label" htmlFor={`paid-leave-${index}`}>
              {watch(`details.${index}.isPaidLeave`) ? "Yes" : "No"}
            </label>
          </div>
        </div>
      ),
    },
    {
      title: () => (
        <div className="d-flex flex-column align-items-center">
          <span>Is Approved</span>
          <input
            type="checkbox"
            className="form-check-input mt-1"
            onChange={(e) => {
              const checked = e.target.checked;
              const details = watch("details");
              details.forEach((_, index) => {
                setValue(`details.${index}.isApproved`, Number(checked));
                if (checked) {
                  setValue(`details.${index}.approvedBy`, watch("createUser"));
                  setValue(
                    `details.${index}.approvedDate`,
                    getCurrentFormattedDate()
                  );
                } else {
                  setValue(`details.${index}.approvedBy`, null);
                  setValue(`details.${index}.approvedDate`, null);
                }
              });
            }}
          />
          <small className="text-muted">Select All</small>
        </div>
      ),
      dataIndex: "isApproved",
      render: (text, record, index) => (
        <div className="d-flex justify-content-center align-items-center mb-0">
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id={`approved-${index}`}
              checked={watch(`details.${index}.isApproved`)}
              onChange={(e) => {
                setValue(
                  `details.${index}.isApproved`,
                  Number(e.target.checked)
                );
                setValue(`details.${index}.approvedBy`, watch("createUser"));
                setValue(
                  `details.${index}.approvedDate`,
                  getCurrentFormattedDate()
                );
              }}
            />
            <label className="form-check-label" htmlFor={`approved-${index}`}>
              {watch(`details.${index}.isApproved`) ? "Yes" : "No"}
            </label>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="card card-body border-0 mb-3 mt-3">
      <h5 className="mb-3">Leave Day Details</h5>
      <div className="table-responsive">
        <Table
          columns={columns}
          dataSource={watch("details") || []}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default ApplyLeaveDayDetails;
